import { Icon } from '@/common/ui/Icon'
import { pluralizeRu } from '@/common/lib/text'

type ActiveSubscriptionDetailsProps = {
    plan: string
    daysRemaining: number
    tokensGranted: number
    isAutoRenew: boolean
    expiresAt: string | null
    isLoading?: boolean
}

export const ActiveSubscriptionDetails = ({
    plan,
    daysRemaining,
    tokensGranted,
    isAutoRenew,
    expiresAt,
    isLoading = false,
}: ActiveSubscriptionDetailsProps) => {
    if (isLoading) {
        return (
            <div className='flex min-h-[120px] items-center justify-center'>
                <p className='text-sm text-pixorion-gray-2'>Загрузка...</p>
            </div>
        )
    }

    const daysLabel = pluralizeRu(daysRemaining, ['день', 'дня', 'дней'])

    return (
        <>
            <p className='text-sm text-pixorion-gray-2'>Тариф: {plan}</p>
            <div className='flex flex-wrap gap-9'>
                <div className='flex flex-col gap-1.5 w-[250px]'>
                    <div className='flex items-center gap-2'>
                        <Icon name='task-square' className='w-5 h-5' />
                        <p className='text-sm font-medium'>
                            {daysRemaining} {daysLabel}
                        </p>
                    </div>
                    <div className='pl-7'>
                        <p className='text-sm text-pixorion-gray-2'>Период подписки</p>
                    </div>
                </div>
                <div className='flex flex-col gap-1.5 w-[380px]'>
                    <div className='flex items-center gap-2'>
                        <Icon name='coin' className='w-5 h-5' />
                        <p className='text-sm font-medium'>
                            {tokensGranted.toLocaleString('ru-RU')}{' '}
                            {pluralizeRu(tokensGranted, ['токен', 'токена', 'токенов'])}
                        </p>
                    </div>
                    <div className='pl-7'>
                        <p className='text-sm text-pixorion-gray-2'>На текущий период</p>
                    </div>
                </div>
                <div className='flex flex-col gap-1.5 w-[250px]'>
                    <div className='flex items-center gap-2'>
                        <Icon name='repeat' className='w-5 h-5' />
                        <p className='text-sm font-medium'>Автопродление {isAutoRenew ? 'включено' : 'выключено'}</p>
                    </div>
                    <div className='pl-7'>
                        <p className='text-sm text-pixorion-gray-2'>Можно отключить вручную</p>
                    </div>
                </div>
                <div className='flex flex-col gap-1.5 w-[380px]'>
                    <div className='flex items-center gap-2'>
                        <Icon name='danger' className='w-5 h-5' />
                        <p className='text-sm font-medium'>Неиспользованные токены сгорают</p>
                    </div>
                    <div className='pl-7'>
                        <p className='text-sm text-pixorion-gray-2'>Спустя 365 дней после начисления</p>
                    </div>
                </div>
            </div>
            <div className='pt-4 border-t border-[rgba(255,255,255,0.05)]'>
                <p className='text-sm text-pixorion-gray-2'>
                    Подписка активна до {expiresAt ? new Date(expiresAt).toLocaleDateString('ru-RU') : '—'}
                </p>
            </div>
        </>
    )
}
